<template>
    <div class="gridPublications">
        <div class="grid">
            <ItemPublication v-for="publication in publications" :key="publication.url" :publication="publication" />
        </div>
        <NPagination v-if="pageCount && pageCount > 1" v-model:page="page" :page-count="pageCount" :show-quick-jump-dropdown="false" size="large" :page-slot="4" @update-page="pageUpdate" />
    </div>
</template>

<script lang="ts" setup>
import { NPagination } from 'naive-ui';

interface Props {
    publications: any[];
    page?: number;
    meta?: { total_count?: number, filter_count?: number };
}

const props = defineProps<Props>()
const emit = defineEmits(['update-page'])
const page = ref(props.page || 1)

const pageCount = computed(() => {
    if (props.meta && props.meta.filter_count) return Math.ceil(props.meta.filter_count / 8)
    else return null
})

const pageUpdate = (page: number) => {
    emit('update-page', page)
}
</script>

<style lang="scss" scoped>
.gridPublications {
    margin: 0 var(--size-margin-page);

    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-double);

    .grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);
    }
}

@media screen and (max-width: 1024px) {
    .gridPublications {
        .grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 600px) {
    .gridPublications {
        .grid {
            grid-template-columns: repeat(1, minmax(0, 1fr));
        }
    }
}
</style>